<script setup>
import { storeToRefs } from 'pinia';

import useAlertStore from '@/stores/alert.store.js';

const alertStore = useAlertStore();
const { alert } = storeToRefs(alertStore);
</script>

<template>
    <div v-if="alert" class="container">
        <div class="m-3">
            <div class="alert alert-dismissible fade show d-flex align-items-center" :class="alert.type" role="alert">
              <svg v-if="(alert.type=='alert-success')" class="bi flex-shrink-0 me-2" width="24" height="24" role="img" aria-label="Success:"><use xlink:href="#check-circle-fill"/></svg>
              <div>{{alert.message}}</div>
              <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close" @click="alertStore.clear()"></button>
            </div>
        </div>
    </div>
</template>